import { useState, useEffect } from 'react'

export const useFetchAllEvents = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {
    
    const { FormRequestGlobal } = Forms
    const { formState } = FormRequestGlobal
    const { getCurrentDate } = Helpers

    const fecha_actual = getCurrentDate()
    
    // console.log(formState);
    const [events, setEvents] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllEvents = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        const _body = {
            fecha_actual : fecha_actual,                
            fecha_inicio : formState.fecha_inicio,
            fecha_final : formState.fecha_final
        }

        try {
            const response = await marvarApi.post(`/agenda/events`, _body)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.fecha_inicio !== '' && formState.fecha_fin !== ''){
            fetchData()
                .then((resp) => {
                    setEvents(
                        resp.rows.map(item => {
                            
                            return {
                                id: item.idagenda,
                                title: item.event_description,
                                date: (item.dias_atrasados>0) ? fecha_actual : item.fecha_evento,
                                backgroundColor: item.event_background
                            };
                        
                            // switch (item.tipo_evento) {
                            //     case 'Pago de Vehiculo':
                            //         (item.dias_atraso_totales>0) 
                            //             ? title = `⚠️ D. Pago Pendiente: VH${item.idcredito} - D. Atraso: ${item.dias_atraso_totales}`
                            //             : title = `D. Pago Pendiente: VH${item.idcredito} - D. Atraso: ${item.dias_atraso_totales}`
                            //             break;
                            //     case 'Renovacion de Seguro':
                            //         title = `Renovacion de Seguro: VH${item.idcreditovehiculo}`;
                            //         break;
                            //     default:
                            //         break;
                            // }
                        
                            // return {
                            //     id: item.idagenda,
                            //     title: title,
                            //     date: (item.dias_atraso_totales>0) ? fecha_actual : item.fecha_evento,
                            //     backgroundColor: (item.dias_atraso_totales>0) ? '#5F0404': item.color
                            // };
                        })
                    )

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { events, executeFetchAllEvents }

}

export const useFetchInfoEvent = ({marvarApi, dispatch, onLogout, Forms, Helpers}) => {

    
    const {FormRequestGlobal:{formState}, FormRequestModal:{setFormState}} = Forms
    

    const {getCurrentDate} = Helpers
    const _data = {                
        'idagenda' : formState.idagenda,
        'fecha_actual' : getCurrentDate()
    }
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoEvents = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.post(`/agenda/info-event`, _data)
            console.log('[useFetchData][useFetchInfoEvent] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idagenda > 0){
            fetchData()
                .then((resp) => {
                    const event = resp.data[0]
                    setFormState(prevState => ({
                        ...prevState,
                        tipo_evento: event.tipo_evento,
                        color: event.color, 
                        fecha_evento: event.fecha_pago,
                        fecha_ren_seguro: event.fecha_ren_seguro, 
                        fecha_ren_gps: event.fecha_ren_gps, 
                        seguro: event.seguro, 
                        gps: event.gps, 
                        identificador: event.identificador,
                        cliente: event.cliente,
                        dias_atrasado: event.dias_atraso_totales,
                        telefono: event.telefono,
                        correo: event.correo,
                        direccion: event.direccion,
                        dpi: event.dpi,    
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return {  executeFetchInfoEvents }

}







